//
//
//
//
//
//
//
//
//
//

import Table from "@/modules/home/components/table.vue";
import { i18n } from "@/i18n";
import firebase from "firebase/app";
import "firebase/firestore";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      users: [],
      loading: true,
      columns: [
        {
          name: i18n("drugDeal.users.firstName"),
          required: true,
          label: i18n("drugDeal.users.firstName"),
          align: "center",
          field: "firstName",
          // style: 'width: 5vw;',
        },
        // { name: i18n('drugDeal.users.lastName'), align: 'center', label: i18n('drugDeal.users.lastName'), field: 'lastName',},
        {
          name: i18n("drugDeal.users.fullName"),
          align: "center",
          label: i18n("drugDeal.users.fullName"),
          field: "fullName",
        },
        //  { name: 'Last ', align: 'center', label: 'Last', field: 'hey',},
        {
          name: i18n("common.phoneNumber"),
          align: "center",
          label: i18n("common.phoneNumber"),
          field: "phone",
        },
        {
          name: i18n("common.emailAddress"),
          align: "center",
          label: i18n("common.emailAddress"),
          field: "email",
        },
        {
          name: i18n("user.fields.expiredTime"),
          align: "center",
          label: i18n("user.fields.expiredTime"),
          field: "expiredTime",
        },
        {
          name: i18n("user.fields.subscription"),
          align: "center",
          label: i18n("user.fields.subscription"),
          field: "subscription",
        },
        {
          name: i18n("common.status"),
          align: "center",
          label: i18n("common.status"),
          field: "disabled",
        },
        {
          name: i18n("common.action"),
          align: "center",
          label: i18n("common.action"),
          field: "action",
        },
      ],
      data: [
        {
          id: "1",
          firstName: "Ahmed",
          lastName: "Ali",
          fullName: "Ahmed Ali",
          phone: "01093295291",
          email: "ahmed@gmail.com",
          disabled: false,
          expiredTime: "June 27, 2025 at 11:05:55 AM UTC+3", // Future date - Active
          subscription: "Premium",
        },
        {
          id: "2",
          firstName: "Mohammed",
          lastName: "Hassan",
          fullName: "Mohammed Hassan",
          phone: "01093295291",
          email: "mohammed@gmail.com",
          disabled: true,
          expiredTime: "January 15, 2024 at 09:30:00 AM UTC+3", // Past date - Expired
          subscription: "Basic",
        },
        {
          id: "3",
          firstName: "Sara",
          lastName: "Ahmed",
          fullName: "Sara Ahmed",
          phone: "01093295291",
          email: "sara@gmail.com",
          disabled: false,
          // No expiredTime - will show "Not Set"
          subscription: "Free",
        },
        {
          id: "4",
          firstName: "Omar",
          lastName: "Mahmoud",
          fullName: "Omar Mahmoud",
          phone: "01093295291",
          email: "omar@gmail.com",
          disabled: false,
          expiredTime: "December 31, 2024 at 11:59:59 PM UTC+3", // Future date - Active
          subscription: "Premium",
        },
        {
          id: "5",
          firstName: "Ahmed",
          lastName: "Ali",
          phone: "01093295291",
          emailAddress: "ghadayousef@gmail.com",
          status: "enabled",
        },
        {
          id: "6",
          firstName: "Ahmed",
          lastName: "Ali",
          phone: "01093295291",
          emailAddress: "ghadayousef@gmail.com",
          status: "disabled",
        },
        {
          id: "7",
          firstName: "Ahmed",
          lastName: "Ali",
          phone: "01093295291",
          emailAddress: "ghadayousef@gmail.com",
          status: "enabled",
        },
        {
          id: "8",
          firstName: "Ahmed",
          lastName: "Ali",
          phone: "01093295291",
          emailAddress: "ghadayousef@gmail.com",
          status: "disabled",
        },
        {
          id: "9",
          firstName: "Ahmed",
          lastName: "Ali",
          phone: "01093295291",
          emailAddress: "ghadayousef@gmail.com",
          status: "enabled",
        },
        {
          id: "10",
          firstName: "Ahmed",
          lastName: "Ali",
          phone: "01093295291",
          emailAddress: "ghadayousef@gmail.com",
          status: "enabled",
        },
        {
          id: "11",
          firstName: "Ahmed",
          lastName: "Ali",
          phone: "01093295291",
          emailAddress: "ghadayousef@gmail.com",
          status: "disabled",
        },
        {
          id: "12",
          firstName: "Ahmed",
          lastName: "Ali",
          phone: "01093295291",
          emailAddress: "ghadayousef@gmail.com",
          status: "enabled",
        },
        {
          id: "13",
          firstName: "Ahmed",
          lastName: "Ali",
          phone: "01093295291",
          emailAddress: "ghadayousef@gmail.com",
          status: "disabled",
        },
        {
          id: "14",
          firstName: "Ahmed",
          lastName: "Ali",
          phone: "01093295291",
          emailAddress: "ghadayousef@gmail.com",
          status: "enabled",
        },
        {
          id: "15",
          firstName: "Ahmed",
          lastName: "Ali",
          phone: "01093295291",
          emailAddress: "ghadayousef@gmail.com",
          status: "disabled",
        },
        {
          id: "16",
          firstName: "Ahmed",
          lastName: "Ali",
          phone: "01093295291",
          emailAddress: "ghadayousef@gmail.com",
          status: "enabled",
        },
        {
          id: "17",
          firstName: "Ahmed",
          lastName: "Ali",
          phone: "01093295291",
          emailAddress: "ghadayousef@gmail.com",
          status: "disabled",
        },
        {
          id: "18",
          firstName: "Ahmed",
          lastName: "Ali",
          phone: "01093295291",
          emailAddress: "ghadayousef@gmail.com",
          status: "enabled",
        },
      ],
    };
  },
  components: {
    [Table.name]: Table,
  },
  methods: {
    i18n(key, args) {
      return i18n(key, args);
    },
  },
  computed: {
    ...mapGetters({
      authenticationUser: "auth/authenticationUser",
      roles: "auth/roles",
      // currentUser:'auth/currentUser'
    }),
  },
  async created() {
    await firebase
      .firestore()
      .collection("user")
      .onSnapshot({ includeMetadataChanges: true }, async () => {
        // const user = await firebase.firestore().collection("user").doc(this.currentUser.id).get({source: 'cache'})
        // console.log('user data: ',user.data().roles[0])
        const users = await firebase
          .firestore()
          .collection("user")
          .get({ source: "cache" });
        this.users = [];
        // this.cachedPrescriptionsSize = prescriptions.size
        let userIndex = 0;
        users.forEach((doc) => {
          let user = doc.data();

          // Force static values with variety
          const subscriptionTypes = ["Premium", "Basic", "Free", "Enterprise"];
          const expirationDates = [
            "June 27, 2025 at 11:05:55 AM UTC+3",
            "January 15, 2024 at 09:30:00 AM UTC+3",
            "December 31, 2024 at 11:59:59 PM UTC+3",
            null,
          ];

          user.subscription =
            user.subscription || subscriptionTypes[userIndex % 4];
          user.expiredTime = user.expiredTime || expirationDates[userIndex % 4];

          userIndex++;

          // user.createdAt = new Date(user.createdAt.seconds * 1000)
          // user.createdAt = user.createdAt.toString().slice(0,24)
          // if(!user.roles.includes('owner') && !user.roles.includes('pending') && user.status !== "deleted")
          if (user.roles.length == 0 && user.status !== "deleted")
            this.users.push(user);
        });
        this.loading = false;
      });
  },
};
